"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants_1 = require("./constants");
/**
 * Adds the parameter value to an object at the key given from the context
 * parameter header map
 * @param dict Accumulator object { [x: string]: string }
 * @param param1 Key value pair
 * @returns Accumulator object with key value pair added
 */
var contextParamToHeaderReducer = function (dict, _a) {
    var _b;
    var _c = tslib_1.__read(_a, 2), contextParamKey = _c[0], contextParamValue = _c[1];
    return (tslib_1.__assign(tslib_1.__assign({}, dict), (_b = {}, _b[constants_1.CONTEXT_PARAMS_HEADER_MAP[contextParamKey]] = contextParamValue, _b)));
};
/**
 * Maps context parameter values to a dictionary of HTTP header keys
 * @param contextParams ContextParams object
 * @returns HTTP header object { [x: string]: string }
 */
var contextParamsToHttpHeaders = function (contextParams) {
    return Object.entries(contextParams).reduce(contextParamToHeaderReducer, {});
};
exports.default = contextParamsToHttpHeaders;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/API/GraphApi/contextParams/contextParamsToHttpHeaders.js
// module id = 3371
// module chunks = 11